import {Component, Prop, Vue, Emit, Watch} from 'vue-property-decorator';
// 本地调试时需注册Router; 到打包时可以删掉
// import BackMixin from '../../assets/mixins/back.mixin'
// import Router from 'vue-router'
// Vue.use(Router)

@Component({
    // mixins: [BackMixin]
})
export default class PageHeader extends Vue {
    @Prop({default: () => ''}) private title!: any;
    @Prop({default: () => ''}) private titleIcon!: any;
    @Prop({default: () => ''}) private describe!: any;
    @Prop({default: () => ''}) private doc!: any;
    @Prop({default: () => ''}) private docIcon!: any;
    @Prop({default: () => ''}) private docLink?: string;
    @Prop({default: () => false}) private isBack?: boolean;

    public $router: any;
    public $parent: any;

    private mounted() {
    }

    private skip() {
        // this.$emit('skip')
        this.$router.push(this.docLink)
    }

    private back() {
        this.$router.back();
    }
}
